import { render, staticRenderFns } from "./SubscriptionSuspend.vue?vue&type=template&id=bb3673fc"
import script from "./SubscriptionSuspend.vue?vue&type=script&lang=js"
export * from "./SubscriptionSuspend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports